module.exports = __webpack_public_path__ + "img/350.bb53cc27.png";